'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// TODO : wire row compiler eventually.

ngModule.factory("itTreeRenderer", function (itTreeDefaultConfig, itRenderingFn, infiniTableConfigManager) {
  return function itTreeRenderer(tableCtrl) {
    var renderer = this,
      ui = tableCtrl.ui,
      $scope = tableCtrl.getScope(),
      $el = tableCtrl.getElement(),
      renderingFn = itRenderingFn(tableCtrl, renderer),
      tree = [],
      flattenedTree = [],
      displayedRows = [],
      innerState = {
        expanded: false,
        collapsed: false
      },
      idMap = {};
    var stateManager = infiniTableConfigManager.getTableStateManager();
    var tableState = null;
    var isStateManaged = false;
    $el.addClass("it-tree-table");
    function refreshInnerState() {
      var allCollapse = true;
      var allExpanded = true;
      var _isWholeBranchExpanded = function isWholeBranchExpanded(node) {
        if (renderer.hasChildren(node)) {
          if (node.expanded) {
            for (var i = 0; i < node.children.length; i++) {
              if (!_isWholeBranchExpanded(node.children[i])) {
                return false;
              }
            }
          } else {
            return false;
          }
        }
        return true;
      };
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        if (node.expanded === true) {
          // for collapse we only need to check first level.
          allCollapse = false;
        }
        if (allExpanded && !_isWholeBranchExpanded(node)) {
          allExpanded = false;
        }
      }
      innerState = {
        expanded: allExpanded,
        collapsed: allCollapse
      };
    }
    renderer.isAllExpanded = function () {
      return innerState.expanded;
    };
    renderer.isAllCollapsed = function () {
      return innerState.collapsed;
    };
    renderer.collapseAllRows = function () {
      _.each(tree, function (data, key) {
        renderer.collapseNode(data.nodeId, true, true, true);
      });
      if (isStateManaged) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
      recomputeAndRender();
    };
    renderer.expandAllRows = function () {
      _.each(tree, function (data, key) {
        renderer.expandNode(data.nodeId, true, true, true);
      });
      if (isStateManaged) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
      recomputeAndRender();
    };
    renderer.processConfiguration = function (tableConfig) {
      var mergedConfig = _.extend({}, angular.copy(itTreeDefaultConfig), tableConfig);

      // adding the tree column !
      var compiler = tableCtrl.getCompiler();
      var treeColumn = mergedConfig.treeColumn;
      var treeCellContentLink = compiler.makeCellContentInjector(treeColumn, mergedConfig);
      var hideSpacers = mergedConfig.showSpacers === false;
      _.extend(treeColumn, {
        linker: function itTreeColumnLinker(rowEl, rowScope) {
          var linkers = tableCtrl.linkers;
          if (rowScope.model && rowScope.model.children == null) {
            rowEl.addClass("it-tree-leaf");
          } else {
            rowEl.addClass("it-tree-node");
          }
          rowEl.addClass("it-tree-row depth-" + rowScope.depth);
          linkers.mainCell(rowScope, function (mainCell) {
            mainCell.appendTo(rowEl);

            //let treeCellWrapper = $('<div class="it-tree-cell-wrapper"></div>').appendTo(mainCell);

            linkers.nodeCell(rowScope, function (nodeCell) {
              nodeCell.appendTo(mainCell);
            });
            var treeCellContent = $('<div class="it-tree-cell-content"></div>').appendTo(mainCell);
            treeCellContent.css({
              "padding-left": (rowScope.depth + 1) * 24 + (hideSpacers ? 0 : 7) + "px"
            });
            treeCellContentLink(rowScope, treeCellContent);
          });
        }
      });
      mergedConfig.columns = mergedConfig.otherColumns;
      mergedConfig.columns.splice(0, 0, treeColumn);

      // state manager
      if (mergedConfig.stateManager != null) {
        stateManager = mergedConfig.stateManager;
      }
      isStateManaged = stateManager.handleConfig(mergedConfig);
      if (isStateManaged) {
        tableState = stateManager.getTableState(mergedConfig.id);
      }
      return mergedConfig;
    };

    //////

    var prepareDataSource = function prepareDataSource() {
      var dataSource = tableCtrl.getDataSource();
      var config = tableCtrl.getConfig();
      var initialDepth = _.result(config, "initialDepth");
      tree = [];
      flattenedTree = [];
      idMap = {};
      _.each(dataSource, function (model) {
        var data = prepareItem(model, null, initialDepth);
        tree.push(data);
      });
      recomputeFlattenedTree();
      renderer.refreshSpacers();
    };
    var prepareItem = function prepareItem(model, parentData, recurseToDepth) {
      var depth = parentData ? parentData.depth + 1 : 0;
      var expanded = recurseToDepth && recurseToDepth > depth;

      // Restore state if available
      if (isStateManaged && tableState && tableState.expandedNodes) {
        var nodeId = model[tableCtrl.getConfig().idAttribute];
        if (tableState.expandedNodes[nodeId]) {
          expanded = true;
        }
      }
      var data = {
        nodeId: _.uniqueId("node-"),
        model: model,
        row: null,
        depth: depth,
        parent: parentData || null,
        expanded: expanded,
        childrenLoaded: false,
        children: null
      };
      idMap[data.nodeId] = data;
      if (expanded) {
        loadChildren(data, recurseToDepth);
      }
      return data;
    };
    var loadChildren = function loadChildren(parentData, recurseToDepth) {
      parentData.children = [];
      var childrenModels = parentData.model[tableCtrl.getConfig().childrenAttribute];
      _.each(childrenModels, function (model) {
        var childData = prepareItem(model, parentData, recurseToDepth);
        parentData.children.push(childData);
      });
      parentData.childrenLoaded = true;
    };
    var recomputeFlattenedTree = function recomputeFlattenedTree() {
      flattenedTree = [];
      var _flattenNode = function flattenNode(data) {
        flattenedTree.push(data);
        if (data.expanded) {
          _.each(data.children, function (child) {
            _flattenNode(child);
          });
        }
      };
      _.each(tree, _flattenNode);
      return flattenedTree;
    };

    // TODO : handle recursive

    renderer.expandNode = function (nodeId, recursive, noRender, noStateSave) {
      var nodeData = idMap[nodeId];
      if (!nodeData.childrenLoaded) {
        loadChildren(nodeData);
      }
      nodeData.expanded = true;
      if (isStateManaged) {
        updateState(nodeData.model, true, noStateSave);
      }
      if (recursive) {
        _.each(nodeData.children, function (child) {
          return renderer.expandNode(child.nodeId, true, true, noStateSave);
        });
      }
      if (!noRender) {
        recomputeAndRender();
      }
    };
    renderer.collapseNode = function (nodeId, recursive, noRender, noStateSave) {
      var nodeData = idMap[nodeId];
      nodeData.expanded = false;
      if (isStateManaged) {
        updateState(nodeData.model, false, noStateSave);
      }
      if (recursive) {
        _.each(nodeData.children, function (child) {
          return renderer.collapseNode(child.nodeId, true, true, noStateSave);
        });
      }
      if (!noRender) {
        recomputeAndRender();
      }
    };
    function updateState(model, expanded, noSave) {
      if (!tableState.expandedNodes) {
        tableState.expandedNodes = {};
      }
      var nodeId = model[tableCtrl.getConfig().idAttribute];
      if (expanded) {
        tableState.expandedNodes[nodeId] = true;
      } else {
        delete tableState.expandedNodes[nodeId];
      }
      if (!noSave) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
    }
    function recomputeAndRender() {
      var newFirstNodeId = getClosestVisible(tableCtrl.context.pagination.first);
      recomputeFlattenedTree();
      var newIndex = _.findIndex(flattenedTree, function (node) {
        return node.nodeId === newFirstNodeId;
      });
      renderer.setScrollPosition({
        index: newIndex
      });
      renderer.refreshSpacers();
      tableCtrl.refreshColumnsSizing();
      tableCtrl.getScrollBar().refresh(true);
    }
    function getClosestVisible(index) {
      var node = flattenedTree[index];
      while (node && !node.expanded && node.depth > 0) {
        node = node.parent;
      }
      return node.nodeId;
    }
    renderer.getDisplayedRows = function () {
      return displayedRows;
    };
    renderer.getActualSource = function () {
      return flattenedTree;
    };
    renderer.getActualLength = function () {
      return flattenedTree.length;
    };
    renderer.hasChildren = function (node) {
      var children = node.model[tableCtrl.getConfig().childrenAttribute];
      return children && children.length;
    };
    renderer.refreshSpacers = function () {
      var _refreshRepeatMeta = function refreshRepeatMeta(nodeList, recurse) {
        _.each(nodeList, function (childNode, i) {
          childNode.$node = {};
          childNode.$node.$index = i;
          childNode.$node.$first = i === 0;
          childNode.$node.$last = i === nodeList.length - 1;
          childNode.$node.$middle = !(childNode.$node.$first || childNode.$node.$last);
          if (recurse && childNode.childrenLoaded) {
            _refreshRepeatMeta(childNode.children, recurse);
          }
        });
      };
      _refreshRepeatMeta(tree, true);
      $scope.$broadcast("recompute-spacer");
    };
    renderer.clearContent = function (reinit) {
      _.each(idMap, function (node) {
        if (node.scope) {
          node.scope.$destroy();
          node.row.remove();
        }
      });

      // rowCompiler.stop();

      tableCtrl.context.pagination = {};
      tree = [];
      flattenedTree = [];
      idMap = {};
      displayedRows = [];
      tableCtrl.ui.contentBody.empty();
    };
    renderer.getOrCreateRow = function (i) {
      var data = flattenedTree[i];
      if (!data.row) {
        renderer.createRow(i);
      }
      return data.row;
    };
    renderer.createRow = function (i, detach) {
      var data = flattenedTree[i];
      var model = data.model;
      var rowScope = $scope.$new();
      _.extend(rowScope, {
        nodeId: data.nodeId,
        depth: data.depth,
        data: data,
        model: model,
        $index: i
      });
      var row = null;
      tableCtrl.linkers.row(rowScope, function (_row) {
        row = _row;
        ui.contentBody.append(row);
      });
      _.extend(data, {
        row: row,
        scope: rowScope
      });
      if (detach) {
        if (row != null) row.detach();
      }
      return row;
    };
    renderer.deleteRow = function (i) {
      var node = flattenedTree[i];
      if (!node || !node.scope) {
        return;
      }
      node.scope.$destroy();
      node.row.remove();
    };
    renderer.setScrollPosition = function (options) {
      if (options.initial) {
        // TODO : find more graceful way to init dataSource.
        prepareDataSource();
      }
      refreshInnerState();
      renderingFn(options);
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeRenderer.js
// module id = 2819
// module chunks = 13